<div class="container-fluid">
    <h1 class="h4 pb-3">New organisation</h1>
    <div class="organisation-new-card">
        <cdss-organisation-form idPrefix="new-organisation"
                                [codePrefix]="codePrefix"
                                [saving]="saving"
                                [codeError]="codeError"
                                (save)="onSave($event)"></cdss-organisation-form>
    </div>
</div>
